export enum TrackingId {
  CategoryClick = 4,
  NewsletterPerk = 21,
  PerkSearchListings = 26,
  ReferralLinks = 30,
  StoryClick = 31,
  SearchSubmission = 34,
  PerkInteraction = 45,
  AccountInteraction = 46,
  Redemption = 48,
  WBEPageNotificationClick = 59,
  WBEPopupClick = 65,
  NotificationInteraction = 67,
  PopUpInteraction = 68,
  AlertBannerInteraction = 69,
  GiftCardButtonInteraction = 70,
  WeeklyFlyerInteraction = 71,
  TicketsForLessInteraction = 72,
  PageView = 80,
  UserRegistrationInteraction = 81,
  Pagination = 82,
  PromotionViewAll = 83,
  RelatedViewAll = 84,
  NewsletterUnsubscribeClick = 73,
  ADTravelWidgetInteraction = 75,
}

export enum TrackingAction {
  Loaded = 'load',
  View = 'view',
  Click = 'click',
  Submit = 'submit',
}

export enum SortType {
  Distance = 1,
  Name = 2,
  RecentlyUpdated = 3,
}

export type SearchTrackingHit = BaseTracking & Filters & { keyword_source: AnalyticsKeywordSource, distance: number | string };

interface BaseTracking {
  keyword?: string;
  action: TrackingAction;
  source?: string;
  perk_source?: string;
}

interface Filters {
  instore_filter?: boolean;
  online_filter?: boolean;
  mobile_filter?: boolean;
  email_filter?: boolean;
  expiring_filter?: boolean;
  new_filter?: boolean;
  sort_type?: string;
}

export enum PerkTrackingElement {
  PerkCard = 'PerkCard',
  Banner = 'Banner',
  Story = 'Story',
  Tag = 'Tag',
  CategoryCard = 'CategoryCard',
  AccountCard = 'AccountCard',
  TopBrand = 'TopBrand', // Missing on Mobile app
  Redemption = 'Redemption', // Missing on Mobile app
  TemplatePerks = 'TemplatePerks',
}

export enum TrackingElement {
  UserAccountRegistration = 'UserAccountRegistration', // Missing on Mobile app
  Pagination = 'Pagination',
  PromotionViewAll = 'PromotionViewAll',
  RelatedViewAll = 'RelatedViewAll',
  Popup = 'Popup',
  AlertBanner = 'AlertBanner',
  AgreeAndPlayButton = 'AgreeAndPlayButton',
  PopUpSpinWheelButton = 'PopUpSpinWheelButton',
  DoNotShowButton = 'DoNotShowButton',
  PopupCTA = 'PopupCTA',
  NotificationPanel = 'NotificationPanel',
  NotificationDetail = 'NotificationDetail',
  NotificationList = 'NotificationList',
  NotificationBell = 'NotificationBell',
  GiftCardButton = 'GiftCardButton',
  WeeklyFlyerTopButton = 'WeeklyFlyerTopButton',
  WeeklyFlyerFooterButton = 'WeeklyFlyerFooterButton',
  TFLSearchWidget = 'TFLSearchWidget',
  TFLSearchResult = 'TFLSearchResult',
  NewsletterUnsubscribeClick = 'NewsletterUnsubscribeClick',
  ADTravelFlightsExplore = 'FlightsExplore',
  ADTravelHotelsSearch = 'HotelsSearch',
}

export enum CategoryTrackingElement {
  Menu = 'Menu',
  CategoryCard = 'CategoryCard',
  CategoryTextLink = 'CategoryTextLink',
  RelatedViewAll = 'RelatedViewAll'
}

// PAGES = ["Home Page", "Category Page", "Perk Details Page"]
// PerkTileImpressionLoaded
// PerkTileImpressionView
// HeroPerkImpressionLoaded
// HeroPerkImpressionView

export enum PageName {
  Home = 1,
  CategoryHome = 2,
  Perk = 3,
  Search = 4,
  Settings = 5,
  AccountCreation = 6,
  Favourites = 7,
  GetActivationCode = 8,
  CheckYourEmail = 9,
  CreateYourAccount = 10,
  AddLocation = 11,
  NewsletterSubscription = 12,
  TermsOfUse = 13,
  MobileAppDownload = 14,
  MobileAppDownloadSkip = 15,
  MobileAppDownloadSend = 16,
  Congratulations = 17,
  TemplatePerks = 19,
  FavouriteBrand = 20,
  RelatedPerksViewAll = 21,
  Interstitial = 22,
  NotificationList = 23,
  WeeklyFlyer = 24,
  ADTravelFlights = 25,
  ADTravelHotels = 26,
}

export enum PerkSource {
  VenngoCA = "Venngo-CA",
  VenngoUS = "Venngo-US",
  AccessUS = "Access-US",
}

export enum Country {
  CA = "CA",
  US = "US",
}

export enum Source {
  Web = "web",
  Mobile = "mobile",
  MobileWeb = "mobile-web",
  WebBrowserExtension = "web-extension",
  Newsletter = "newsletter"
}

export enum WebExtensionElement {
  WBEPopupClick = "PopupClick",
  WBEPageNotificationClick = "PageNotificationClick",
}

interface PromotionHit {
  promotion: string;
  promotion_id: string | number;
}

export interface AccountHit {
  account_id: number;
  action: string;
  source: string;
  element_name: string;
  account_source: string;
}

export interface CategoryHit {
  category_id: string | number;
  element_name: CategoryTrackingElement;
}

export interface PaginationHit {
  element_name: TrackingElement;
  position: number;
}

export interface NewsletterHit {
  nl_edition_id?: number;
  nl_type?: string;
  element_name?: string;
  perk_id: number;
  account_id?: number;
  category_id: number;
  subcategory_id: number;
  perk_source: string;
  action: string;
}

export interface BannerTrackingHit {
  perk_id: string | number;
  category_id?: string | number;
  subcategory_id?: string | number;
  position?: string | number;
  element_name: string;
  promotion_id?: string | number;
  keyword?: string;
  action?: string;
  perk_source?: PerkSource;
  source?: Source;
  account_id?: string | number;
  campaign_id?: number;
}

export interface NotificationClickHit {
  notification_id?: string | number;
  category_id?: string | number;
  subcategory_id?: string | number;
  promotion_id?: string | number;
  perk_id?: string | number;
  campaign_id?: string | number;
  account_id?: string | number;
  element_name: string;
  action: string;
  perk_source?: PerkSource;
  source: Source;
  notification_status?: string;
  notification_type: string;
}

export interface PageTrackingHit {
  category_id?: string | number;
  perk_id?: string | number;
  campaign_id?: string | number;
  subcategory_id?: string | number;
  promotion_id?: string | number;
  tag_id?: number;
  action?: string;
  perk_source?: PerkSource;
  source?: Source;
  account_id?: string | number;
  edition_id?: number;
  popup_id?: string | number;
  alert_banner_id?: string | number;
  spinwheel_id?: string | number;
  notification_id?: number;
  notification_type?: string;
  notification_status?: string;
  keyword?: string;
  position?: string | number;
  sponsored_keyword?: number;
  sponsored_result?: number;
}

export interface PerkClickHit {
  perk_id?: string | number;
  campaign_id?: string | number;
  category_id?: string | number;
  subcategory_id?: string | number;
  element_name: string;
  promotion_id?: string | number;
  action?: string;
  perk_source?: PerkSource,
  source?: Source;
  account_id?: string | number;
  edition_id?: string | number;
  newsletter_type?: string;
  keyword?: string;
  position?: string | number;
  sponsored_keyword?: number;
  sponsored_result?: number;
}

export interface PopupClickHit {
  popup_id: string | number;
  category_id?: string | number;
  subcategory_id?: string | number;
  perk_id?: string | number;
  campaign_id?: string | number;
  account_id?: string | number;
  element_name: string;
  action?: string;
  source?: Source;
  perk_source?: PerkSource;
  promotion_id?: string | number;
  position?: string | number;
  spinwheel_id?: string | number;
  edition_id?: string | number;
  template_type?: number;
}

export interface AlertBannerClickHit {
  alert_banner_id: string | number;
  category_id?: string | number;
  subcategory_id?: string | number;
  perk_id?: string | number;
  campaign_id?: string | number;
  account_id?: string | number;
  element_name: string;
  action?: string;
  source?: Source;
  perk_source?: PerkSource;
  promotion_id?: string | number;
  position?: string | number;
  spinwheel_id?: string | number;
  edition_id?: string | number;
  template_type?: string | number;
  email_id?: string | number;
}

export interface AccountClickHit {
  category_id?: string | number;
  position?: string | number;
  element_name: string;
  action?: string;
  account_source?: PerkSource,
  source?: Source;
  account_id?: string | number;
  perk_id?: number;
}

export interface PerkSearchHit {
  perk_id: number;
  account_id?: number;
  element_name?: string;
  category_id?: string | number;
  subcategory_id?: string | number;
  perk_source?: PerkSource,
  action?: string;
  campaign_id?: number;
  promotion_id?: number;
  keyword?: string;
  position?: string | number;
  sponsored_keyword?: number;
  sponsored_result?: number;
}

export interface RegisterUserAccountHit {
  site_id: string | number;
  action: string;
  step: string | number;
  page_name: string;
  element_name: string;
  user_ID: string | number;
  family_invited: boolean | string;
  email: string;
}

export interface NewsletterUnsubscribeHit {
  user_ID: string | number;
  newsletter_email: string;
  edition_id: string | number | null;
  element_name: string;
  action: string;
}

export type TrackingPayload = PromotionHit | BannerTrackingHit | PerkClickHit | RegisterUserAccountHit | PageTrackingHit | NewsletterHit | Redemption | SearchTrackingHit | AccountHit | PaginationHit | ViewAllHit | CategoryHit | NotificationClickHit | PopupClickHit | AlertBannerClickHit | GiftCardButtonHit | WeeklyFlyerTopButtonHit | WeeklyFlyerFooterButtonHit | TFLSearchWidgetHit | TFLSearchResultHit | NewsletterUnsubscribeHit;

export type AnalyticsKeywordSource = 'user' | 'perk';

export const PERK_ROUTE_TRACKING_ID_MAP = {
  // FIXME: Should have its own TrackingId.
  // BrowsePerks: TrackingId.PerkSearchListingsClick,
  // CategoryHome: TrackingId.PerkCategoryListingsViewButton,
  // Search: TrackingId.PerkSearchListingsClick,
  // Favourites: TrackingId.UserFavouritesListings,
  // HomeView: TrackingId.WelcomeHomeScrollPod,
};

export function isPerkClickHit(trackingHit: TrackingPayload): trackingHit is PerkClickHit {
  return (trackingHit as PerkClickHit).perk_id !== undefined;
}

export interface SearchImpressionDescriptor {
  templateId?: number;
  query?: string;
}

export interface PerkInteraction {
  action: 'click' | 'view' | 'load', // Type of interaction
  perk_id: number; // Perk ID
  campaign_id: number; // Campaign ID of Perk in question
  account_id: number; // Account ID of the perk
  category_id: number; // Parent category ID of the perk.
  position: number; // Order of element displaying the perk in its parent container
  promotion_id?: number; // (If applicable) Promotion ID if the perk was present in a template
  element_name: 'PerkCard' | 'Banner' | 'Story' | 'StoryView' | 'AccountCard' | 'CategoryCard'; // Type of element perk was present in
  keyword?: string; // (If applicable) keyword used to find the perk.
  perk_source: 'Venngo-CA' | 'Venngo-US' | 'Access-US'; // Specifies whether this is a Venngo or AD perk.
}

export interface ViewAllHit {
  action: string;
  element_name: string;
  perk_source: string;
}

export interface Redemption {
  perk_id: string | number; // Perk ID
  account_id: string | number; // Account ID
  campaign_id: string | number; // Campaign ID
  redemption_type: 'InStore' | 'Online' | 'Phone' | 'Email';
  category_id?: string | number;
  subcategory_id?: string | number;
  perk_source: 'Venngo-CA' | 'Venngo-US' | 'Access-US';
  promotion_id?: string | number;
  edition_id?: number;
  popup_id?: number;
  alert_banner_id?: number;
  notification_id?: number,
  notification_status?: string,
  notification_type?: string,
  keyword?: string;
  position?: string | number;
  sponsored_keyword?: number;
  sponsored_result?: number;
}

export interface GiftCardButtonHit {
  action: string;
  element_name: TrackingElement.GiftCardButton;
  source?: Source;
}

export interface WeeklyFlyerTopButtonHit {
  action: string;
  element_name: TrackingElement.WeeklyFlyerTopButton;
  source?: Source;
}

export interface WeeklyFlyerFooterButtonHit {
  action: string;
  element_name: TrackingElement.WeeklyFlyerFooterButton;
  source?: Source;
}

export interface TFLSearchWidgetHit {
  action: string;
  element_name: TrackingElement.TFLSearchWidget;
  source?: Source;
  keyword: string;
  ticket_title: string;
}

export interface TFLSearchResultHit {
  action: string;
  element_name: TrackingElement.TFLSearchResult;
  source?: Source;
  keyword: string;
  ticket_title: string;
}

export interface ADTravelWidgetHit {
  action: string;
  element_name: TrackingElement.ADTravelFlightsExplore | TrackingElement.ADTravelHotelsSearch;
  source?: Source;
}
